var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1199_3111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4873 12.2244C24.4873 11.2412 24.4057 10.5236 24.229 9.77954H12.739V14.2175H19.4833C19.3474 15.3204 18.6132 16.9814 16.9814 18.0975L16.9585 18.246L20.5915 20.9962L20.8431 21.0208C23.1547 18.9346 24.4873 15.8652 24.4873 12.2244Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.739 23.9176C16.0431 23.9176 18.817 22.8545 20.8431 21.0209L16.9814 18.0976C15.948 18.8018 14.561 19.2934 12.739 19.2934C9.50279 19.2934 6.7561 17.2074 5.77698 14.324L5.63347 14.3359L1.85592 17.1927L1.80652 17.3269C3.81894 21.2334 7.9526 23.9176 12.739 23.9176Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77702 14.324C5.51867 13.58 5.36916 12.7826 5.36916 11.9589C5.36916 11.135 5.51867 10.3378 5.76343 9.59366L5.75658 9.43519L1.9317 6.53247L1.80655 6.59064C0.97714 8.21174 0.501221 10.0322 0.501221 11.9589C0.501221 13.8855 0.97714 15.7059 1.80655 17.327L5.77702 14.324Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.739 4.62403C15.0369 4.62403 16.587 5.59402 17.4709 6.40461L20.9247 3.10928C18.8035 1.1826 16.0431 0 12.739 0C7.9526 0 3.81894 2.68406 1.80652 6.59057L5.76339 9.59359C6.7561 6.7102 9.50279 4.62403 12.739 4.62403Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1199_3111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.5295e51c89346652a2fc3e2967fae06c.svg";
export { ForwardRef as ReactComponent };